import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  width: "100%",
  justifyContent: "space-between",
  // padding: "15px",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  background: "white",
  borderRadius: "15px",
});
